import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import './styles/redesign.css';

import { HelmetProvider } from 'react-helmet-async';

// Bootstrap the React application into the #root element.
// We use a check to determine if we should hydrate (for react-snap pre-rendered HTML)
// or render from scratch (for local development).

const rootElement = document.getElementById('root');
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// NOTE: Always createRoot (skip hydration). Prerender gives crawlers the
// full SEO-ready HTML; client-side React renders fresh. A single root-swap
// flashes once on JS boot — acceptable trade for zero hydration mismatches
// between prerender state (always rendered fully — puppeteer lets effects fire)
// and client state (where React compares a pre-effect virtual DOM to the
// post-effect server HTML, causing spurious mismatches).
ReactDOM.createRoot(rootElement).render(app);